/**
 * SearchPerformanceAnalysisOnly Component
 * 职责: 仅显示搜索查询绩效数据分析，不包含上传功能
 */
import React, { useState } from 'react';
import { Card, Empty } from 'antd';
import { useSearchPerformance } from '../../../hooks/useSearchPerformance';
import { AnalysisTabsSection } from './AnalysisTabsSection';

interface SearchPerformanceAnalysisOnlyProps {
    skuId: number;
}

export const SearchPerformanceAnalysisOnly: React.FC<SearchPerformanceAnalysisOnlyProps> = ({ skuId }) => {
    const {
        periods,
        advantageData,
        marketOverview,
        opportunityData,
        keywordPivotData,
        loading,
        fetchAdvantageKeywords,
        fetchMarketOverview,
        fetchOpportunityKeywords,
        fetchKeywordPivot,
    } = useSearchPerformance(skuId);

    const [selectedPeriodId, setSelectedPeriodId] = useState<number | null>(null);

    // 自动选择第一个周期
    React.useEffect(() => {
        if (periods.length > 0 && !selectedPeriodId) {
            setSelectedPeriodId(periods[0].id);
        }
    }, [periods, selectedPeriodId]);

    // Tab切换处理（懒加载）
    const handleTabChange = (key: string) => {
        if (key === 'sp-advantage' && !advantageData) {
            fetchAdvantageKeywords();
        } else if (key === 'sp-overview' && !marketOverview) {
            fetchMarketOverview();
        } else if (key === 'sp-opportunity' && !opportunityData) {
            fetchOpportunityKeywords();
        } else if (key === 'sp-pivot' && !keywordPivotData) {
            fetchKeywordPivot();
        }
    };

    // 如果没有数据，显示提示
    if (periods.length === 0) {
        return (
            <Card>
                <Empty
                    description={
                        <div>
                            <p>暂无搜索查询绩效数据</p>
                            <p style={{ color: '#999', fontSize: 12 }}>
                                请前往<a href="/data-management">数据管理</a>上传数据
                            </p>
                        </div>
                    }
                />
            </Card>
        );
    }

    return (
        <div>
            <AnalysisTabsSection
                periodsCount={periods.length}
                selectedPeriodId={selectedPeriodId}
                advantageData={advantageData}
                marketOverview={marketOverview}
                opportunityData={opportunityData}
                keywordPivotData={keywordPivotData}
                loading={loading}
                onTabChange={handleTabChange}
            />
        </div>
    );
};

export default SearchPerformanceAnalysisOnly;
